import React, { useContext } from "react";
import "../../../modal/BulkModalContent.js";
import "../../../modal/BulkModalProvider.js";
import "@mui/material";
import "react-intl";
import "../../../modal/ModalButtons.js";
import "../../../modal/Modal.style.js";
import "../../../button/Buttons.js";
import "../../../button/EditButton.js";
import "../../../error/ErrorAccordion.js";
import "../../../error/ErrorDetails.js";
import "../../../error/localize.js";
import "../../../error/ErrorModal.js";
import "../../../error/GlobalServerErrorMessage.js";
import "../../../icons/Icon.js";
import "../../../icons/ExpandMoreIcon.js";
import "@opentelemetry/api";
import "../../../../otel/TraceProvider.js";
import "react-error-boundary";
import "rxjs/operators";
import "@opentelemetry/context-zone";
import "@opentelemetry/exporter-trace-otlp-http";
import "@opentelemetry/instrumentation";
import "@opentelemetry/instrumentation-document-load";
import "@opentelemetry/instrumentation-xml-http-request";
import "@opentelemetry/resources";
import "@opentelemetry/sdk-trace-web";
import "@opentelemetry/semantic-conventions";
import { ModalContext } from "../../../modal/types.js";
import "../../../modal/ActionConfirmationModal.js";
import { ButtonCell } from "./ButtonCell.js";
function renderMuiGridModalButtonCell(params) {
  const { openModal } = useContext(ModalContext);
  const value = params.value;
  return /* @__PURE__ */ React.createElement(ButtonCell, { onClick: () => openModal(value.modalContent), value });
}
export {
  renderMuiGridModalButtonCell
};
//# sourceMappingURL=ModalButtonCell.js.map
